import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import HomePage from './pages/HomePage';
import BrowseListingsPage from './pages/BrowseListingsPage';
import ListingDetailPage from './pages/ListingDetailPage';
import UserDashboardPage from './pages/UserDashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import CreateListingPage from './pages/CreateListingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import LicensePlansPage from './pages/LicensePlansPage';
import ServicesPage from './pages/ServicesPage';
import Header from './components/Header';
import Footer from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-2">
          <Header data-id="element-3" />
          <main className="flex-grow" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="/browse" element={<BrowseListingsPage data-id="element-9" />} data-id="element-8" />
              <Route path="/listing/:id" element={<ListingDetailPage data-id="element-11" />} data-id="element-10" />
              <Route path="/dashboard" element={<UserDashboardPage data-id="element-13" />} data-id="element-12" />
              <Route path="/admin" element={<AdminDashboardPage data-id="element-15" />} data-id="element-14" />
              <Route path="/create-listing" element={<CreateListingPage data-id="element-17" />} data-id="element-16" />
              <Route path="/login" element={<LoginPage data-id="element-19" />} data-id="element-18" />
              <Route path="/register" element={<RegisterPage data-id="element-21" />} data-id="element-20" />
              <Route path="/license-plans" element={<LicensePlansPage data-id="element-23" />} data-id="element-22" />
              <Route path="/services" element={<ServicesPage data-id="element-25" />} data-id="element-24" />
            </Routes>
          </main>
          <Footer data-id="element-26" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}